
















































































































































import Vue from "vue";
import dayjs from "dayjs";
import eventBus from "@/services/eventBus";
import DateInput from "@/components/DateInput.vue";
import api from "../services/api";
import { NovitaxImportResult } from "../models/NovitaxImport";

interface Data {
  file: File | null;
  accDate: Date | null;
  accEvent: string;
  status: number;
  statusItems: { value: number; text: string }[];
  result: NovitaxImportResult | null;
}

interface Methods {
  onAccDateChange(value: Date | null): Promise<void>;
  importFile(force: boolean): Promise<void>;
  formatDate(d: string): string;
  formatTotal(t: number): string;
}

interface Computed {
  isCsv: boolean;
  canImport: boolean;
  confirmNeeded: boolean;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  name: "NovitaxImportView",

  components: { DateInput },

  data(): Data {
    return {
      file: null,
      accDate: null,
      accEvent: "",
      // K2D dddw_ssboktransstat_2_5 (feliratok az éles ssboktransstat-ból), alapértelmezés 2.
      status: 2,
      statusItems: [
        { value: 2, text: "Előkészítés alatt" },
        { value: 3, text: "Ellenőrizhető" },
        { value: 4, text: "Ellenőrizve" },
        { value: 5, text: "Könyvekben szerepel" },
      ],
      result: null,
    };
  },

  computed: {
    isCsv(): boolean {
      return !!this.file && !/\.xlsx?$/i.test(this.file.name);
    },

    canImport(): boolean {
      if (!this.file) return false;
      if (!this.isCsv) return true;
      // K2D: CSV-hez a dátum (nyitott periódus) és a gazdasági esemény kötelező.
      return !!this.accDate && this.accEvent.trim().length > 0;
    },

    confirmNeeded(): boolean {
      return !!this.result && this.result.requiresConfirmation;
    },
  },

  methods: {
    formatDate(d: string): string {
      return d ? dayjs(d).format("YYYY.MM.DD.") : "";
    },

    formatTotal(t: number): string {
      return (t ?? 0).toLocaleString("hu-HU");
    },

    // K2D dw_1::itemchanged 'acc_date': periódus-ellenőrzés + gazdaságiesemény-javaslat.
    async onAccDateChange(value: Date | null) {
      this.accDate = value;
      if (!value) return;
      try {
        const check = await api.CheckNovitaxPeriod(dayjs(value).format("YYYY-MM-DD"));
        if (!check.valid) {
          eventBus.$emit("error", check.message);
          this.accDate = null;
          return;
        }
        // K2D: a dátumváltás mindig felülírja a gazdasági eseményt a javaslattal.
        this.accEvent = check.suggestedAccEvent;
      } catch (e) {
        console.error(e);
      }
    },

    async importFile(force: boolean) {
      if (!this.file || !this.canImport) return;
      this.result = null;
      const isExcel = /\.xlsx?$/i.test(this.file.name);
      eventBus.$emit("busy-message", true);
      try {
        this.result = isExcel
          ? await api.ImportNovitaxXls(this.file, force)
          : await api.ImportNovitaxCsv(
              this.file,
              dayjs(this.accDate).format("YYYY-MM-DD"),
              // K2D dw edit.case=upper: a gazdasági esemény nagybetűsen megy fel.
              this.accEvent.trim().toUpperCase(),
              this.status,
              force
            );
        if (this.result.success) {
          eventBus.$emit("success", this.result.message);
          this.file = null;
        } else if (!this.result.requiresConfirmation) {
          eventBus.$emit("error", this.result.message);
        }
      } catch (e) {
        console.error(e);
        eventBus.$emit("error", "A feladás sikertelen!");
      } finally {
        eventBus.$emit("busy-message", false);
      }
    },
  },
});
